import { formatDate } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionState } from 'src/app/enums/action-state.enum';
import { BadgeRepo } from 'src/app/repositories/badge-repo';
import { AlertService } from 'src/app/services';
import { AuthSupport } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-badge-info',
    templateUrl: './modal-badge-info.component.html',
    styleUrls: ['./modal-badge-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalBadgeInfoComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<void>();
  loadingState = new BehaviorSubject('');
  actionState = ActionState;
  error: any;
  badge: AuthSupport;

  readonly na = 'N/A';

  constructor(
    @Inject(MAT_DIALOG_DATA) public badgeUid: string,
    private badgeRepo: BadgeRepo,
    private logger: NGXLogger,
    private translate: TranslateService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.getBadge(this.badgeUid);
  }

  getBadge(uid: string) {
    this.loadingState.next(ActionState.LOADING);
    this.badgeRepo
      .getBadge(uid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: AuthSupport) => {
          this.loadingState.next(ActionState.READY);
          this.error = false;
          this.badge = this.formatBadgeValue(res);
        },
        error: (error) => {
          this.loadingState.next(ActionState.FAILED);
          this.error = error.error;
        },
      });
  }

  formatBadgeValue(badge: AuthSupport) {
    const formattedBadge: any = {};
    formattedBadge.value = badge.value || this.na;
    formattedBadge.type = badge.type || this.na;
    formattedBadge.provider = formattedBadge.providers = badge.providersSync
    ?.filter(providerSync => providerSync.enabled)
    .map(providerSync => providerSync.provider)
    .join(', ') || this.na;

    formattedBadge.date =
      formatDate(badge.auditor.createdAt, 'dd/MM/yyyy HH:mm:ss', 'fr-FR') || this.na;

    return formattedBadge;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
